/* global mainScript */
import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";

// style rules
import { Colors, Typography, Animation, BoxShadows } from "../../styles";

const RidesCard = ({ ride, toggleSidePanel, isDisabled }) => {
	return (
		<AnimatePresence>
			<Card
				initial={"initial"}
				animate={"animate"}
				exit={"initial"}
				variants={Animation.cards.opacityVariants}
				onClick={!isDisabled && (() => toggleSidePanel(ride))}
				isDisabled={isDisabled}
			>
				<Icon className="icon">
					<img
						src={mainScript.assetPath + "images/svg/icons/icon-rides.svg"}
						alt=""
					/>
				</Icon>
				<TopSection>
					<Title dangerouslySetInnerHTML={{ __html: ride.title }} />
					<Tags>
						{ride.height && (
							<Tag
								icon={mainScript.assetPath + "images/svg/icons/icon-height.svg"}
							>
								{`${ride.height}"`}
							</Tag>
						)}
						<Tag
							icon={mainScript.assetPath + "images/svg/icons/location-icon.svg"}
						>
							{ride.location}
						</Tag>
					</Tags>
					<Text>{ride.description}</Text>
				</TopSection>
				{!isDisabled && <MoreInfo>more Info</MoreInfo>}
			</Card>
		</AnimatePresence>
	);
};

export default RidesCard;

RidesCard.propTypes = {
	toggleSidePanel: PropTypes.func,
	ride: PropTypes.object,
	isDisabled: PropTypes.bool,
};

const Card = styled(motion.li)`
	position: relative;
	list-style: none;
	margin: 0;
	cursor: ${(props) => !props.isDisabled && "pointer"};
	background: ${Colors.base.white};
	box-shadow: ${BoxShadows.cards};
	border-radius: 10px;
	padding: 4.9rem 2.4rem 2.5rem 2.4rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	transition: transform 0.5s;
	${(props) =>
		!props.isDisabled &&
		`&:hover {
			transform: scale(1.1);
			.icon {
				border-radius: 50%;
			}
		}`}
`;

const Icon = styled.div`
	position: absolute;
	top: -43px;
	padding: 1.9rem 2.4rem;
	border-radius: 59% 41% 31% 69% / 48% 55% 45% 52%;
	background: ${Colors.gradients.green};
	transition: border-radius 0.5s;
`;

const TopSection = styled.div`
	text-align: center;
`;

const Title = styled.h2`
	font-size: 1.8rem;
	line-height: 2.4rem;
	letter-spacing: -0.0031em;
`;

const Tags = styled.div`
	padding-top: 1.8rem;
	display: flex;
	gap: 2rem;
	justify-content: center;
`;
const Tag = styled.span`
	font-weight: 700;
	font-size: 1.2rem;
	line-height: 1.1rem;
	display: flex;
	gap: 0.92rem;
	align-items: center;
	letter-spacing: normal;

	&::before {
		content: url(${(props) => props.icon});
	}
`;

const Text = styled.p`
	padding-top: 0.8rem;
	text-align: center;
	font-size: 1.2rem;
	line-height: 2rem;
`;

const MoreInfo = styled.span`
	padding-top: 1.4rem;
	font-size: 1rem;
	line-height: 2rem;
	font-weight: ${Typography.fontWeight.bold};
	text-transform: uppercase;
`;
